<script setup lang="ts">
import { Toaster } from 'vue-sonner';
import 'vue-sonner/style.css';
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <Toaster
      theme="dark"
      rich-colors
      position="top-right"
      :duration="3000"
    />
  </ClientOnly>
</template>
